<h1 mat-dialog-title>Kopioi luokittelut</h1>
<div mat-dialog-content>
  <p>
    Kopioi koko luokitteluryhmä toiselle työmaalle,

  </p>
  <mat-card class="warning-card m-1">
    <mat-card-header>
      <mat-icon aria-hidden="false" aria-label="Warning icon">warning</mat-icon>
      <mat-card-title>{{"WARNING"|translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <p>Kopiointi korvaa kaikki olemassaolevat luokittelut työmaalla.</p>



    </mat-card-content>

  </mat-card>
  <mat-form-field>
    <mat-select placeholder="Select project" [(ngModel)]="selectedProjectId">
      @for (project of selectableProjects|async; track project) {
        <mat-option [value]="project.id">
          {{project.costCenterNumber}} - {{project.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
<div mat-dialog-actions class="ml-1">
  <button mat-button [mat-dialog-close]="selectedProjectId" cdkFocusInitial> <mat-icon>content_copy</mat-icon> Kopioi</button>
  <button mat-button matDialogClose>{{'Cancel'|translate}}</button>
</div>
